import { useEffect, useState } from 'react';
import { DAY_ORDER_EXPIRY_TIME } from '../../../../constants/constants';
import { getDayOrderExpiryTime } from '../../../../helpers/commonHelper';
import './DayTool.scss';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';

const formatRemain = (totalSeconds) => {
  const safe = Math.max(0, Math.floor(totalSeconds));
  const h = Math.floor(safe / 3600) % 24;
  const m = Math.floor(safe / 60) % 60;
  return `${String(h).padStart(2, '0')}h ${String(m).padStart(2, '0')}m`;
};

export const DayTool = ({ setActiveBtn, aciveOrderType, disabled = false }) => {
  const [display, setDisplay] = useState(() =>
    formatRemain(getDayOrderExpiryTime() * 60),
  );

  useEffect(() => {
    let difference = getDayOrderExpiryTime() * 60;
    setDisplay(formatRemain(difference));

    const id = window.setInterval(() => {
      difference -= 1;
      setDisplay(formatRemain(difference));
    }, 1000);

    return () => window.clearInterval(id);
  }, []);

  const popover = (
    <Popover className="DayBuysell DayBuysell--dayTip nondraggable_card">
      <Popover.Body>
        <div className="dayTip">
          <div className="dayTip__item">
            <span className="dayTip__label">Expires At</span>
            <span className="dayTip__value green_text">{DAY_ORDER_EXPIRY_TIME}</span>
          </div>
          <div className="dayTip__item">
            <span className="dayTip__label">Remains</span>
            <span className="dayTip__value green_text">{display}</span>
          </div>
        </div>
      </Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger
      trigger="click"
      placement="top"
      overlay={popover}
      rootClose
      popperConfig={{
        modifiers: [
          { name: 'offset', options: { offset: [0, 8] } },
          {
            name: 'preventOverflow',
            options: { padding: 8, boundary: 'viewport' },
          },
        ],
      }}
    >
      <Button
        type="button"
        onClick={() => !disabled && setActiveBtn('DAY')}
        className={`gtcBtn ${aciveOrderType === 'DAY' ? 'active' : ''}`}
        disabled={disabled}
      >
        Day
      </Button>
    </OverlayTrigger>
  );
};
